import { Button, Col, Form, Input, Row } from "antd";
import React, { useState } from "react";
import CommentBox from "../../../components/commentBox";
import PageHeader from "../../../components/pageHeader";
import TaskCheckedList from "../../../components/taskCheckedList";
import { BsGlobe2 } from "react-icons/bs";
import { collection, doc, getDoc, updateDoc } from "firebase/firestore";
import { db } from "../../../../../../../firebase";

function WorkOrderInfo({ itemId, listId,alreadyCheckedItems }) {
  const isItemChecked = alreadyCheckedItems[itemId.toString()]; // Convert itemId to string because keys in checkedItems are strings.

  const [isDisabled, setIsDisabled] = useState(isItemChecked);

 const tasksRef = collection(db, "tasks");
  const itemListRef = doc(tasksRef, "itemList");
  const assignedCollectionRef = collection(itemListRef, "Assigned");

  function handleUndefinedValues(obj) {
    const newObj = {};
    for (let key in obj) {
      newObj[key] = obj[key] === undefined ? "" : obj[key];
    }
    return newObj;
  }
  const onFinish = async (values) => {
    console.log("Success:", values);
    values = handleUndefinedValues(values);
    const targetDocRef = doc(assignedCollectionRef, listId);

    try {
      const docSnapshot = await getDoc(targetDocRef);

      if (docSnapshot.exists()) {
        const data = docSnapshot.data();
        if (data && data.workItemList) {
          const updatedWorkItemList = data.workItemList.map((item) => {
            return {
              ...item,
              status:
                item.id == itemId && item.status == "incompleted"
                  ? "completed"
                  : item.status,
              details: item.id == itemId && values,
            };
          });

          await updateDoc(targetDocRef, {
            workItemList: updatedWorkItemList,
          });

          console.log("Document successfully updated!");
          setIsDisabled(true);
        } else {
          console.log("workItemList not found in the document!");
        }
      } else {
        console.log("Document does not exist!");
      }
    } catch (error) {
      console.error("Error updating document:", error);
    }
  };
  const onFinishFailed = (errorInfo) => {
    console.log("Failed:", errorInfo);
  };
  return (
    <div className="item-page">
      <Form className="item-page-container" layout="vertical" onFinish={onFinish} onFinishFailed={onFinishFailed}>
        <Row gutter={[0, 24]}>
          <Col span={24}>
            <PageHeader pageHeading="Work order info" />
          </Col>
          <Col span={24}>
          <Form.Item label="Address" name="address">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Tenant" name="tenant">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Description" name="description">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Work order number" name="workOrderNumber">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Copy work order link here" name="workOrderLink">
              <Input placeholder="Type Answer Here" prefix={<BsGlobe2 />} />
            </Form.Item>
            <Form.Item label="Status" name="status">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Vendor" name="vendor">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
            <Form.Item label="Date Created" name="dateCreated">
              <Input placeholder="Type Answer Here" />
            </Form.Item>
          </Col>
          <Col span={24}>
            <Row justify="end" gutter={[8, 0]}>
              <Col>
                <Button>Skip</Button>
              </Col>
              <Col>
                <Button type="primary"  htmlType="submit" disabled={isDisabled}>Complete</Button>
              </Col>
            </Row>
          </Col>
        </Row>
        <Row>
          <Col span={24}>
            <CommentBox />
          </Col>
          <Col span={24}>
            <TaskCheckedList />
          </Col>
        </Row>
      </Form>
    </div>
  );
}

export default WorkOrderInfo;
